
// tabs = [{
// 	label,
// 	id, // country id
// 	... // any data
// 	tree: [{
// 		label,
// 		... // any data
// 		children,
// 	}],
// }]

const sortTabsAutocomplete = (data, options = {}) => {
	const {tabsFirstFR} = options;
	data.sort((a,b) => {
		return (
			tabsFirstFR && a.id === 'FR' && b.id !== 'FR' ? -1 :
			tabsFirstFR && a.id !== 'FR' && b.id === 'FR' ? 1 :
			tabsFirstFR && a.id === 'FR' && b.id === 'FR' ? 0 :
			a.label > b.label ? 1 :
			a.label < b.label ? -1 :
			0
		);
	});
	data.forEach(({tree}) => sortChildren(tree));
}
export default sortTabsAutocomplete;

const sortChildren = data => {
	data.sort((a,b) => {
		return (
			a.label > b.label ? 1 :
			a.label < b.label ? -1 :
			0
		);
	});
	data.forEach(item => {
		if(item.children){
			sortChildren(item.children);
		}
	});
}